import React from "react";

class BorderStyle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      displayList: false,
      name: props.style.name,
			list: ["none", "dotted", "dashed", "solid", "double", "groove", "ridge", "inset", "outset"].map((o) => {
				return { name: o, value: o };
			}),
    };
  }

  handleClick = () => {
    this.setState({ displayList: !this.state.displayList  })
  };

  handleClose = () => {
    this.setState({ displayList: false })
  };

	componentWillReceiveProps(nextProps) {
    this.setState({ name: nextProps.name })
	}

  onChange = (name) => {
		this.setState({
      name: name,
      displayList: false
    }, () => {
      if ( this.props.onChange ) {
        this.props.onChange(this.props.style.field, this.state.name)
      }
    });
  }

  buttonStyle = (value) => {
    const style = this.state.list.find((e) => { return e.value == value })
    if (style) {
      return {borderTopStyle: style.value, borderTopWidth: '5px'}
    }
  }

  buttonName = (value) => {
    const style = this.state.list.find((e) => { return e.value == value })
    if (style) {
      return style.name == 'none' ? i18n.t('without_border') : '';
    }
  }


  render() {
    const name = this.props.style.value;
    const { onChange, buttonStyle, buttonName } = this;
    return <div className={`btn-border dropdown ${this.state.displayList ? 'open' : ''}`}>
        <button type="button" onClick={this.handleClick} className="btn btn-control dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {!name && i18n.t('without_border') }
          {name && ["none", "hidden"].some( i => i == name ) &&
            <span>{buttonName(name)}</span>
          }
          {name && ["none", "hidden"].indexOf(name) == -1 &&
            <span className='border-style' style={buttonStyle(name)} title={buttonName(name)}/>
          }
        </button>
        {this.state.displayList &&
          <ul className="dropdown-menu dropdown-menu-left">
            {this.state.list.map((item, index) => (
              <li key={index}><a onClick={()=>{this.onChange(item.value)}}>
              {["none", "hidden"].some( i => i == item.value ) &&
                <span className="border-stalker">{ i18n.t('without_border') }</span>
              }
              {["none", "hidden"].indexOf(item.value) == -1 &&
                <span className="border-style" style={buttonStyle(item.value)} title={item.name}/>
              }
              </a></li>
            ))}
          </ul>
        }
      </div>;
  }
}

export default BorderStyle;
